import CustomButton, {
  BtnRadius,
  BtnSizes,
  BtnTypes,
} from "@/app/components/lib/CustomButton";
import SvgModalClose from "@/app/components/lib/SvgModalClose";
import { useIsMobile } from "@/hooks/useIsMobile";
import { Col, Modal, Row } from "@/utils/bootstrap";
import { safeHTML } from "@/utils/functions/safeHTML";
import { useTranslation } from "@/hooks/localization/useTranslations";

interface Props {
  show: boolean;
  setShow: (show: boolean) => void;
  setAgree: (agree: boolean) => void;
  terms: string;
}

const TermsModal: React.FC<Props> = ({ terms, show, setShow, setAgree }) => {
  const t = useTranslation();
  const mobile = useIsMobile();
  return (
    <Modal
      centered
      show={show}
      onHide={() => setShow(false)}
      dialogClassName="messagebox-dialog"
      contentClassName="pop-up-modal-contents"
    >
      <div className="messagebox-closeicon">
        <SvgModalClose onClick={() => setShow(false)} />
      </div>
      <div className="messagebox-title text-center pt-4 pb-2">
        {t.terms_conditions}
      </div>
      <div className="terms-container">
        <div
          dir={"auto"}
          className="messagebox-message"
          dangerouslySetInnerHTML={{
            __html: safeHTML(terms ?? ""),
          }}
        />

        <Row className="m-0 w-100" style={{ gap: 16 }}>
          {!mobile && <Col />}
          <Col className="p-0">
            <CustomButton
              type={BtnTypes.secondary}
              size={BtnSizes.large}
              radius={BtnRadius.small}
              onClick={() => {
                setAgree(false);
                setShow(false);
              }}
              fullWidth
            >
              {t.i_dont_agree}
            </CustomButton>
          </Col>
          <Col className="p-0">
            <CustomButton
              type={BtnTypes.primary}
              size={BtnSizes.large}
              radius={BtnRadius.small}
              onClick={() => {
                setAgree(true);
                setShow(false);
              }}
              fullWidth
            >
              {t.i_agree}
            </CustomButton>
          </Col>
          {!mobile && <Col />}
        </Row>
      </div>
    </Modal>
  );
};

export default TermsModal;
